import type { CSSProperties, FC } from 'react';
import { cn } from '@glomopay/utils';

const SPOKE_COUNT = 12;

interface SpinnerProps {
  className?: string;
  style?: CSSProperties;
  testId?: string;
}

const Spinner: FC<SpinnerProps> = ({ className, style, testId = 'spinner' }) => (
  <svg
    data-testid={testId}
    style={style}
    className={cn('animate-spin', className)}
    width='1em'
    height='1em'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth={2}
    strokeLinecap='round'
    aria-hidden='true'>
    {Array.from({ length: SPOKE_COUNT }, (_, i) => (
      <line key={i} x1='12' y1='2.5' x2='12' y2='6.5' transform={`rotate(${(i * 360) / SPOKE_COUNT} 12 12)`} opacity={(i + 1) / SPOKE_COUNT} />
    ))}
  </svg>
);

export default Spinner;
